import { TOwnSuggestion } from '@r1-frontend/unified-address-form/reducer';

const getErrorBySelectedSuggestion = (address: string, suggestions: Record<string, TOwnSuggestion>, ignoreFlat = false) => {
    if (!address || address === '') {
        return {
            hasError: false,
            message: null,
        };
    }

    if (!(address in suggestions)) {
        return {
            hasError: true,
            message: 'Выберите адрес из списка',
        };
    }

    const result = {
        hasError: true,
        message: null,
    };

    if (!suggestions[address].street) {
        return { ...result, message: 'Необходимо ввести улицу' };
    }

    if (!suggestions[address].house) {
        return { ...result, message: 'Необходимо ввести номер дома' };
    }

    if (!suggestions[address].flat && !ignoreFlat) {
        return { ...result, message: 'Необходимо ввести номер квартиры' };
    }

    return {
        hasError: false,
        message: null,
    };
};

export default getErrorBySelectedSuggestion;
